export abstract class UserHistoryService {
  /**
   * Saves the provided tenant slug as last visited
   *
   * @param tenantSlug
   */
  abstract setLastVisitedTenant(tenantSlug: string): Promise<void>;

  /**
   * Returns slug of the last visited Tenant
   */
  abstract getLastVisitedTenant(): Promise<string>;

  /**
   * Saves the provided space as last visited
   *
   * @param spaceUri
   * @param tenantUri
   *
   */
  abstract setLastVisitedSpace(spaceUri: string, tenantUri?: string): Promise<void>;

  /**
   * Returns the last visited Space
   *
   * @param tenantUri
   */
  abstract getLastVisitedSpace(tenantUri?: string): Promise<string>;

  /**
   * Returns the last visited Space providing the tenantSlug
   *
   * @param tenantSlug
   */
  abstract getLastVisitedSpaceBySlug(tenantSlug?: string): Promise<string>;
}
